import { render } from "./singlepage.vue?vue&type=template&id=451e2916"
import script from "./singlepage.vue?vue&type=script&lang=js"
export * from "./singlepage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\amaan\\encanto-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__